import { type ReactNode, useState } from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip'

const DisplayTooltipOnHover = ({
  children,
  text,
  asChild = false,
  tooltipClassName,
}: {
  text: string
  children: ReactNode
  asChild?: boolean
  tooltipClassName?: string
}) => {
  const [open, setOpen] = useState(false)

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger
          asChild={asChild}
          onClick={() => setOpen(false)}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          {children}
        </TooltipTrigger>
        <TooltipContent className={tooltipClassName}>
          <div>{text}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default DisplayTooltipOnHover
